import { render, staticRenderFns } from "./OfficialHolidayDelete.vue?vue&type=template&id=4a73b93d&scoped=true&"
import script from "./OfficialHolidayDelete.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidayDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73b93d",
  null
  
)

export default component.exports